// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"2102acb6","418":"500aae1d","672":"3296197f"}[chunkId] + ".chunk.js";
};